<template>
  <el-dialog
    title="Help"
    :visible.sync="dialog_visible">
    <div class="d-block text-center">
      <h5>Keyboard Shortcuts</h5>
    </div>
    <div class="d-block">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Shortcut</th>
            <th>Meaning</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th><kbd>&larr;</kbd>, <kbd>&rarr;</kbd></th>
            <td>Navigate between neighbor goals (with same parent)</td>
          </tr>
        </tbody>
      </table>
    </div>
    <el-button class="mt-3" type="danger" @click="hideModal">Close Help</el-button>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog_visible: false,
    }
  },
  methods: {
    showModal() {
      this.dialog_visible = true;
    },
    hideModal() {
      this.dialog_visible = false;
      this.$emit('save');
      this.$emit('cancel');
    }
  }
};
</script>
